import { useEffect } from 'react';
import { useIdleTimer } from 'react-idle-timer';
import { Outlet, useNavigate } from 'react-router-dom';

import { isNil } from 'lodash';

import { logout, useMe } from 'entities/Auth/sdk';

import { getToken, removeToken } from 'utils/storage';

import { URLS } from 'config/urls';

const AuthGuard = () => {
  const navigate = useNavigate();
  const token = getToken();
  const { data: me } = useMe();

  useEffect(() => {
    if (!token) {
      navigate(URLS.LOGIN);
    } else if (!isNil(me) && !me.is_data_researcher) {
      navigate(URLS.HOME);
    }
  }, [navigate, token, me]);

  const handleOnIdle = () => {
    logout().then(() => {
      removeToken();
      navigate(URLS.LOGIN);
    });
  };

  useIdleTimer({
    timeout: 10 * 60 * 1000,
    onIdle: handleOnIdle
  });

  return <Outlet />;
};

export default AuthGuard;
